<template>
    <div class="g pop-up-inner">
        <mdToggleAside
            @sendEvent="close"
        ></mdToggleAside>
        <mdCaption
            :caption="content.caption || '影片專區'"
            :minorCaption="content.minorCaption"
        ></mdCaption>
        <div class="g pop-up-content">
            <div class="block">
                <iframe width="560" height="315" :src="filmURL" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
            </div>
        </div>
    </div>
</template>
<script>
    import mdCaption from '@/components/mdCaption'
    import mdToggleAside from '@/components/mdToggleAside'
    import mdBtnList from '@/components/mdBtnList'

    export default{
        components: {
            mdCaption,
            mdToggleAside,
            mdBtnList,
        },
        props: {
            content: {
                type: Object,
                require: true
            }
        },
        computed: {
            filmURL: function() {
                return "https://www.youtube.com/embed/" + this.content.film
            }
        },
        methods: {
            close: function(){
                this.$emit('sendEvent', 'clearPopUp', this.sn);
            },
        }
    }
</script>
<style scoped lang="scss">
    .pop-up-content {
        padding-bottom: $interval-xl !important;

        .block{
            width: 60vw;
            position: relative;
            padding-bottom: 56.25%;
            height: 0;

            iframe {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
            }

            @include media('mobile') {
                width: 80vw;
            }
        }

        @include media('phone') {
            display: flex;
            align-items: center;
        }
    }
</style>
